/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
export const colors = {
  white: '#ffffff',
  black: '#000000',
  red: '#f85a5d',
  ceriseRed: '#e03e52',
  cyan: '#9ACBEE',
  blue: '#7469FF',
  lightestGray: '#eeeeee',
  lighterGray: '#E2E2E2',
  lightGray: '#C1C1C1',
  gray: '#7d7d7f',
  darkGray: '#4d4d4f',
  darkerGray: '#2d2d2f',
  mineShaft: '#222222',
  lightningYellow: '#FEC010',
  dustyGray: '#959595',
  wildSand: '#f6f6f6',
  chetwodeBlue: '#8b84d7',
  turquoiseBlue: '#5bc2e7'
};

export const font = {
  sizes: {
    extraSmall: '11px',
    small: '14px',
    smallMedium: '15px',
    medium: '18px',
    large: '20px',
    extraLarge: '24px'
  },
  weights: {
    extraLight: 100,
    light: 300,
    regular: 400,
    medium: 500,
    bold: 800
  },
  family: "'GT America', Helvetica, Arial, sans-serif"
};

export const spacing = {
  // NOTE: these are numbers not strings so you can calculate them, add 'px' after using them
  outterBorder: 50,
  outterContent: 55
};

export const layouts = {
  // NOTE: these are numbers not strings so you can calculate them, add 'px' after using them
  sidebar: {
    width: 260
  },
  header: {
    height: 90
  },
  desktopHeader: {
    height: 70
  },
  footer: {
    height: 100
  },
  mobileFooter: {
    height: 80
  }
};

export const devices = {
  desktop: '@media only screen and (min-width: 1010px)',
  mobile: '@media only screen and (max-width: 1009px)'
};

export default {
  colors,
  font,
  spacing,
  layouts,
  devices
};
